import { State, Action } from './types'

function assertNever(state: State, _: never) {
  return state
}

export function reducer(state: State, action: Action) {
  switch (action.type) {
    case 'setBlockSubmit': {
      return {
        ...state,
        blockSubmit: true,
      }
    }
    case 'setUnblockSubmit': {
      return {
        ...state,
        blockSubmit: Boolean(state.errors.length), // false if no errors
      }
    }
    case 'setDataset': {
      const { dataset, subTitle, submissionName, templateId } = action.payload

      return {
        ...state,
        dataset,
        subTitle,
        submissionName,
        templateId,
      }
    }
    case 'setPendingRows': {
      return {
        ...state,
        unsavedChanges: false,
        loading: false,
        dataContainer: action.payload.dataContainer,
      }
    }
    case 'setDataContainer': {
      return {
        ...state,
        dataContainer: action.payload,
      }
    }
    case 'afterDatasetDataUpdate': {
      const { dataContainer, dataset, subTitle, submissionName } = action.payload
      return {
        ...state,
        dataContainer,
        dataset,
        subTitle,
        submissionName,
        loading: false,
        unsavedChanges: false,
      }
    }
    case 'setStatus': {
      const { unsavedChanges, isSubmitting } = action.payload
      // Default status from state if not set. Only part is needed at times.
      return {
        ...state,
        unsavedChanges:
          typeof unsavedChanges === 'undefined' ? state.unsavedChanges : unsavedChanges,
        isSubmitting: typeof isSubmitting === 'undefined' ? state.isSubmitting : isSubmitting,
      }
    }
    case 'invalidCells': {
      const { errors } = action.payload

      return {
        ...state,
        errorCount: errors.length,
        errors,
        blockSubmit: Boolean(errors.length),
      }
    }
    case 'setSubmissionName': {
      return {
        ...state,
        submissionName: action.payload,
      }
    }
    case 'setIntegrationErrors': {
      return {
        ...state,
        integrationErrors: action.payload,
      }
    }
    case 'setLoading': {
      return {
        ...state,
        loading: action.payload,
      }
    }
    case 'setPasteStatus': {
      return {
        ...state,
        isPasting: action.payload,
      }
    }
    case 'setTemplateId': {
      return {
        ...state,
        templateId: action.payload,
      }
    }
    case 'resetStore': {
      return { ...initialState }
    }
    default:
      return assertNever(state, action)
  }
}

export const initialState: State = {
  subTitle: 'Submission Name',
  submissionName: '',
  templateId: null,
  unsavedChanges: false,
  errorCount: 0,
  errors: [],
  blockSubmit: false,
  isSubmitting: false,
  isPasting: false,
  loading: true,
  dataContainer: {},
  dataset: {},
  integrationErrors: [],
}
